module.exports = __webpack_public_path__ + "img/sesamoaventura.fa25a306.jpg";